<template>
  <app-panel title="Восстановление показаний тепла" class="house-importer-finish-stage-restore-heater-values-panel">
    <div slot="actions" v-if="[STATUSES.restored, STATUSES.error].includes(status)">
      <app-button color="success" @click="resetImport">Восстановить еще</app-button>
    </div>


    <template v-if="status === STATUSES.upload">
      <div class="house-importer-finish-stage-restore-heater-values-panel__main-content">
        <div class="house-importer-finish-stage-restore-heater-values-panel__col house-importer-finish-stage-restore-heater-values-panel__col_file">
          <div class="house-importer-finish-stage-restore-heater-values-panel__no-file-error" v-if="fileError">
            Выберите файл
          </div>
          <vs-upload
                  action="#"
                  :limit="1"
                  :show-upload-button="false"
                  text="Добавить файл"
                  @change="onFileChange"
                  @on-delete="onFileDelete"
                  class="import-source-stage__uploader import-source-stage__uploader_single"
                  ref="counterUploader"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div class="house-importer-finish-stage-restore-heater-values-panel__col house-importer-finish-stage-restore-heater-values-panel__col_settings">
          <div class="house-importer-finish-stage-restore-heater-values-panel__col-row">
            <app-input label="Номер строки с названиями тарифов"
                       vtype="uint"
                       v-model="postBody.serv_row"
                       :danger.sync="postBodyErrors.serv_row"
                       danger-text="Заполните номер строки"
            />
          </div>
          <div class="house-importer-finish-stage-restore-heater-values-panel__col-row">
            <app-input label="Номер первой колонки с начислениями"
                       vtype="uint"
                       v-model="postBody.first_tarif_col"
                       :danger.sync="postBodyErrors.first_tarif_col"
                       danger-text="Заполните номер колонки"
            />
          </div>
          <div class="house-importer-finish-stage-restore-heater-values-panel__col-row">
            <app-datepicker label="Месяц"
                            v-model="postBody.month"
                            format="MMMM yyyy"
                            minimum-view="month"
            />
          </div>
          <div class="house-importer-finish-stage-restore-heater-values-panel__col-row"
               v-for="(tariffName, index) in tariffsNames" :key="`row-${index}`">
            <ChangeTariffsRow :tariffs="tariffs" class="" :value="tariffName" :tariffsNames="tariffsNames"
                              @input="setTariffName($event, index)" :canDelete="false"/>
          </div>
        </div>
      </div>
      <div style="text-align: center; margin-top: 15px">
        <app-button color="success" @click="restore">Восстановить</app-button>
      </div>
    </template>
    <template v-else-if="status === STATUSES.restoring">
      <div class="house-importer-finish-stage-restore-heater-values-panel__loading">
        <div class="block-loading"/>
        <div>Восстанавливаю показания...</div>
      </div>
    </template>
    <template v-else-if="status === STATUSES.restored">
      <div class="house-importer-finish-stage-restore-heater-values-panel__done">
        <div class="house-importer-finish-stage-restore-heater-values-panel__done-icon">
          <app-icon name="CheckIcon" size="120px"/>
        </div>
        <div class="house-importer-finish-stage-restore-heater-values-panel__done-text">
          Файл импортирован

          <div class="house-importer-finish-stage-restore-heater-values-panel__done-sub-text">
            Восстановлено: {{restoredCount}}
          </div>

        </div>
      </div>
    </template>
    <template v-else-if="status === STATUSES.error">
      <div class="house-importer-finish-stage-restore-heater-values-panel__error">
        <div class="house-importer-finish-stage-restore-heater-values-panel__error-icon">
          <app-icon name="XIcon" size="80px"/>
        </div>
        <div class="house-importer-finish-stage-restore-heater-values-panel__error-text">
          Файл не импортирован

          <div class="house-importer-finish-stage-restore-heater-values-panel__error-sub-text">
            {{errorText}}
          </div>

        </div>
      </div>
    </template>

  </app-panel>
</template>

<script>
  let STATUSES = {
    upload: 0,
    restoring: 1,
    restored: 2,
    error: 3
  };
  import ChangeTariffsRow from "../../import-charges-stage/components/ChangeTariffsRow";

  export default {
    name: "RestoreHeaterValuesPanel",
    components: {
      ChangeTariffsRow
    },
    props: {
      importInfo: {},
    },
    data() {
      return {
        postBody: {
          serv_row: null,
          first_tarif_col: null,
          month: new Date(),
        },
        postBodyErrors: {
          serv_row: false,
          first_tarif_col: false,
        },
        tariffsNames: [],
        tariffs: [],
        fileError: false,
        file: null,
        STATUSES: STATUSES,
        status: STATUSES.upload,
        errorText: "Название тарифа не найдено",
        restoredCount: 0
      }
    },
    computed: {
      postBodyHasError() {
        return !!Object.values(this.postBodyErrors).filter(v => v).length;
      }
    },
    methods: {
      resetTariffsNames() {
        this.tariffsNames = [];
        this.addTariffName();
      },
      addTariffName() {
        let tariffName = {
          elsa_name: null,
          kvartal_name: null
        };
        this.tariffsNames.push(tariffName);
      },
      resetPostBodyErrors() {
        this.postBodyErrors.serv_row = false;
        this.postBodyErrors.first_tarif_col = false;
      },
      resetPostBody() {
        this.postBody.serv_row = null;
        this.postBody.first_tarif_col = null;
      },
      resetImport() {
        this.file = null;
        this.fileError = false;
        this.resetPostBodyErrors();
        this.resetPostBody();
        this.status = STATUSES.upload;
      },
      checkPostBody() {
        if (this.postBody.serv_row === null) {
          this.postBodyErrors.serv_row = true;
        }
        if (this.postBody.first_tarif_col === null) {
          this.postBodyErrors.first_tarif_col = true;
        }
      },
      checkFileError() {
        if (this.file === null) {
          this.fileError = true;
        }
      },
      async restore() {
        this.resetPostBodyErrors();
        this.checkPostBody();
        this.checkFileError();

        if(this.postBodyHasError || this.fileError) return false;

        this.status = STATUSES.restoring;

        try{
          let body = Object.assign({
            import_id: this.importInfo.id,
            new_charges: this.file,
            elsa_tarif_id: this.tariffsNames[0].elsa_name,
            kvartal_tarif_name: this.tariffsNames[0].kvartal_name,
          }, this.postBody);

          body.month = this.$options.filters.moment(body.month, 'YYYY-MM');

          let bodyFormData = new FormData();

          for(let key in body){
            if(body.hasOwnProperty(key)){
              if(Array.isArray(body[key])){
                for(let i = 0; i < body[key].length; i++){
                  bodyFormData.append(`${key}[${i}]`, body[key][i]);
                }
              }
              else{
                bodyFormData.append(key, body[key])
              }
            }
          }

          let {data} = await this.$http.post('import/houses/recreate_heat_values', bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          });
          this.restoredCount = data.inserted;
          setTimeout(() => {
            this.status = STATUSES.restored;
          }, 300);
        }
        catch(e) {
          if (e.response) {
            if (e.response.status === 404) {
              this.errorText = "Название тарифа не найдено";
            } else {
              this.errorText = "Ошибка сервера - " + e.response.status;
            }
          } else {
            this.errorText = "Неизвестная ошибка";
          }
          this.status = STATUSES.error;
        }
      },
      onFileChange(event, files) {
        this.file = files.filter(file => !file.remove)[0] || null;
        this.fileError = false;
      },
      onFileDelete() {
        this.file = null;
        this.fileError = false;
      },
      setTariffName(v, index) {
        this.$set(this.tariffsNames, index, v);
      },
      async getTariffs() {
        try {
          let {data} = await this.$http.get('import/houses/tarifs', {params: {import_id: this.importInfo.id}});
          this.tariffs = data;
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.tariffs = []
        }
      }
    },
    created() {
      this.resetTariffsNames();
      this.getTariffs();
    }
  }
</script>

<style lang="scss">
  .house-importer-finish-stage-restore-heater-values-panel {

    &__main-content {
      display: flex;
      margin: 0 -7.5px;
      height: 100%;
      min-height: 200px;
    }

    &__col {
      padding: 0 7.5px;
      flex: 1;

      &-row {
        margin-bottom: 15px;
      }


      &_file {
        display: flex;
        max-width: 30%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      &_settings {
        width: 70%;
        border-left: 1px solid rgba(0, 0, 0, .2);
      }
    }

    .import-source-stage__uploader_single {
      height: auto;
    }

    &__no-file-error {
      text-align: center;
      color: rgba(var(--app-danger), 1);
      margin-bottom: 5px;
      font-weight: 500;
    }

    .con-img-upload{
      margin: 0 auto;
      width: 150px;
      height: 150px;
    }

    .app-panel__body{
      position: relative;
      min-height: 390px;
    }

    &__loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .block-loading {
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 15px;
      }
    }

    &__done {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-success), 1);

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      &-sub-text {
        font-size: 16px;
        display: flex;
        align-items: center;
        line-height: 1.1;

        &-icon{
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: -2px;
        }

      }
    }

    &__error {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-danger), 1);

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      &-sub-text {
        font-size: 16px;
        display: flex;
        align-items: center;
        line-height: 1.1;

        &-icon{
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: -2px;
        }

      }
    }

    .con-img-upload .img-upload{
      margin: 0 -.6em;
      width: 150px;
      height: 150px;
    }
  }
</style>